import { useEffect } from 'react';
import { Button } from '@/components/shared/Button/Button';
import Title from '@/components/shared/Title/Title';
import LayoutOutside from '@/layout/LayoutOutside';
import Email from '@/assets/icons/Email';
import { useTranslation } from 'react-i18next';
import useVerificatedEmail from './hooks/useVerificatedEmail';

export default function EmailVerified() {
  const { t } = useTranslation('common');
  const { goToDashboard } = useVerificatedEmail();

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <LayoutOutside
      hideButton
      classNameMainContainer="h-screen flex justify-center items-center"
    >
      <section className="text-colorText max-w-[328px] w-full text-center flex flex-col items-center space-y-8">

        <Email />

        <div className="space-y-3">
          <Title text={t('emailVerificated')} className="text-white" />
          <p className="text-[#A1A1AA]">
            {t('createAccountSuccess')}
          </p>
        </div>

        <Button variant='primary' onClick={goToDashboard}>
          {t('gotToDashboard')}
        </Button>
      </section>
    </LayoutOutside>
  );
}
